import React, { FC, Fragment, useContext, useEffect, useState } from "react";
import { api, IReportGetSchemaRecord } from "../../../../logic/api";
import { SessionContext } from "../../../../utility/useSession";

interface SchemaExplorerProps {
    dataSource: string;
}

const SchemaExplorer: FC<SchemaExplorerProps> = ({
    dataSource,
}) => {
    const session = useContext(SessionContext);
    const [selectedTable, setSelectedTable] = useState("");
    const fetchSchemaApi = api.hooks.reports.getSchema();

    useEffect(() => {
        fetchSchemaApi.send(
            session.current.context,
            {
                dataSource
            }
        );
    }, [dataSource]);

    if (fetchSchemaApi.data) {
        const tables: string[] = [];
        for (const s of fetchSchemaApi.data) {
            if (tables.indexOf(s.tableName) == -1) {
                tables.push(s.tableName);
            }
        }
        return <div>
            {tables.map((tableName, i) => {
                let schemasForTable: IReportGetSchemaRecord[] = [];
                if (fetchSchemaApi.data) {
                    schemasForTable = fetchSchemaApi.data.filter((schema) => {
                        return schema.tableName == tableName;
                    });
                }

                return <div key={i}  >
                    <div style={{ padding: 3, cursor: "pointer", backgroundColor: selectedTable == tableName ? "white" : "unset", color: selectedTable == tableName ? "black" : "grey" }} onClick={() => {
                        if (tableName == selectedTable) {
                            setSelectedTable("");
                        } else {
                            setSelectedTable(tableName);
                        }
                    }}>
                        {tableName}
                    </div>

                    {selectedTable == tableName && (schemasForTable.map((column, c) => {
                        return <div style={{ whiteSpace: "nowrap", marginLeft: 20, color: selectedTable == tableName ? "white" : "unset" }} key={c}>{column.columnName} <span style={{ color: "grey" }}>{column.dataType} {column.dataSize == null ? "" : `[${column.dataSize}]`}</span></div>
                    }))}
                </div>
            })}
        </div>
    }
    return <Fragment />
}

export default SchemaExplorer;
